import { Reveal, Overline } from "./Reveal";

const chapters = [
  {
    num: "01",
    title: "Il tuo modello di business",
    output: "Business Model Canvas evolutivo",
    text: "Trasformi l'intuizione in una struttura economica solida, testabile e pronta a crescere.",
    span: "md:col-span-7",
    image:
      "https://images.pexels.com/photos/9701960/pexels-photo-9701960.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    num: "02",
    title: "La tua soluzione al problema",
    output: "Prototipo e validazione",
    text: "Dai forma alla tua soluzione e la metti alla prova con utenti e mercato reale.",
    span: "md:col-span-5",
    image: null,
  },
  {
    num: "03",
    title: "L'IA come alleata",
    output: "Mappa casi d'uso + AI policy",
    text: "Individui dove l'intelligenza artificiale crea valore e definisci regole chiare per usarla.",
    span: "md:col-span-5",
    image: null,
  },
  {
    num: "04",
    title: "Il tuo pitch",
    output: "Presentazione a mentor e stakeholder",
    text: "Costruisci e alleni un pitch capace di convincere investitori, partner e clienti.",
    span: "md:col-span-7",
    image:
      "https://images.pexels.com/photos/7413908/pexels-photo-7413908.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
];

export const Solution = () => (
  <section id="soluzione" className="relative bg-[#F4F6FB] py-24 sm:py-32" data-testid="solution-section">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="flex flex-col justify-between gap-6 lg:flex-row lg:items-end">
        <div>
          <Reveal>
            <Overline>La soluzione</Overline>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-5 max-w-2xl font-display text-4xl font-black uppercase leading-[0.98] tracking-tight text-[#16256B] sm:text-5xl lg:text-6xl">
              Cosa costruisci in 4 giorni
            </h2>
          </Reveal>
        </div>
        <Reveal delay={0.2}>
          <p className="max-w-sm font-body text-sm leading-relaxed text-[#4A5268]">
            Quattro capitoli operativi. Ogni giornata produce un output concreto
            che porti a casa e usi da subito.
          </p>
        </Reveal>
      </div>

      <div className="mt-14 grid gap-5 md:grid-cols-12">
        {chapters.map((c, i) => {
          const dark = Boolean(c.image);
          return (
            <Reveal
              key={c.num}
              delay={(i % 2) * 0.1}
              className={`${c.span} relative overflow-hidden rounded-2xl border p-8 sm:p-10 ${
                dark ? "border-transparent bg-[#0E1A4A]" : "border-[#E4E8F2] bg-white"
              }`}
              data-testid={`solution-chapter-${c.num}`}
            >
              {c.image && (
                <>
                  <img
                    src={c.image}
                    alt={c.title}
                    className="pointer-events-none absolute inset-0 h-full w-full object-cover opacity-30"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0E1A4A] via-[#0E1A4A]/80 to-[#0E1A4A]/30" />
                </>
              )}
              <span
                className={`pointer-events-none absolute -right-2 -top-6 select-none font-display text-[9rem] font-black leading-none sm:text-[12rem] ${
                  dark ? "text-stroke-light" : "text-stroke"
                }`}
              >
                {c.num}
              </span>
              <div className="relative z-10 flex h-full flex-col">
                <span className={`font-body text-sm font-semibold ${dark ? "text-[#C9A227]" : "text-[#2D46A0]"}`}>
                  {c.num}
                </span>
                <h3
                  className={`mt-3 max-w-xs font-display text-2xl font-extrabold leading-tight sm:text-3xl ${
                    dark ? "text-white" : "text-[#16256B]"
                  }`}
                >
                  {c.title}
                </h3>
                <p className={`mt-3 max-w-md font-body text-sm leading-relaxed ${dark ? "text-white/75" : "text-[#4A5268]"}`}>
                  {c.text}
                </p>
                <div className="mt-auto pt-8">
                  <span
                    className={`inline-flex items-center gap-2 rounded-full border px-4 py-2 font-body text-xs font-medium ${
                      dark
                        ? "border-[#C9A227]/50 bg-[#C9A227]/15 text-[#F0DC94]"
                        : "border-[#C9A227]/40 bg-[#C9A227]/10 text-[#9c7d18]"
                    }`}
                  >
                    Output &rarr; {c.output}
                  </span>
                </div>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
